export const formatTicketDoor = (door?: string | null): string => door?.trim() || "-";